/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Content.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Info from 'DesignSystem/Info/view.js'
import Label from 'DesignSystem/Label/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
backgroundColor: "rgba(255,182,0,0.2)",
borderBottomLeftRadius: 8,
borderBottomRightRadius: 8,
borderTopLeftRadius: 8,
borderTopRightRadius: 8,
justifyContent: "center",
alignItems: "center",
marginBottom: 16,
paddingLeft: 16,
paddingRight: 16,
height: 60,
width: "100%"})
styles.Text = css({label: 'Text',
  marginTop: 3,
fontSize: 36,
maxWidth: 600})
styles.Vertical = css({label: 'Vertical',
  marginLeft: 16,
marginTop: 3})

export default function Content({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/Utilization/DeadlineInfo/Content"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Content.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/DeadlineInfo/Content"
 className={`views-block ${styles.Horizontal}`}
>
<span
 data-testid="Content.Text"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/DeadlineInfo/Content"
 className={`views-text ${styles.Text}`}
>
💸
</span>
<div
 data-testid="Content.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/DeadlineInfo/Content"
 className={`views-block ${styles.Vertical}`}
>
<Label
 data-testid="Content.Label"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/DeadlineInfo/Content"
viewPath={`${viewPath}/Label`}
 text="Important Reminder"
/>
<Info
 data-testid="Content.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/DeadlineInfo/Content"
viewPath={`${viewPath}/Info`}
 text="Utilization report(s) due! Please submit timely in order to remain bonus-eligible."
/>
</div>
</div>
{children}
</React.Fragment>)
}